import { getMockAdapter } from './mock';
import {
  regionStore,
  checkoutCollection,
  discountVerified,
  buildPending,
  linePayUrl,
  checkoutLinePay,
} from './response/purchase';

export default function mockTutor() {
  const mock = getMockAdapter();
  mock
    .onGet(/https:\/\/alb-uat.snapask.co\/api\/v4\/regions\/[-\w]+\/store_page/)
    .reply(200, regionStore);

  mock
    .onGet(/https:\/\/alb-uat.snapask.co\/api\/v4\/addon\/checkout_collections/)
    .reply(200, checkoutCollection);

  mock
    .onPost(/https:\/\/alb-uat.snapask.co\/api\/v3\/discounts\/verify/)
    .reply(200, discountVerified);

  mock
    .onPost(/https:\/\/alb-uat.snapask.co\/api\/v3\/payments\/build_pending/)
    .reply(200, buildPending);

  mock
    .onPost(
      /https:\/\/alb-uat.snapask.co\/api\/v4\/payments\/line_pay\/request/
    )
    .reply(200, linePayUrl);

  mock
    .onPost(
      /https:\/\/alb-uat.snapask.co\/api\/v4\/payments\/line_pay\/checkout/
    )
    .reply(200, checkoutLinePay);
}



// WEBPACK FOOTER //
// ./app/services/mock/purchase.js